import {canUseDom} from "./dom"
let scrollbarWidth = null;

export const getScrollBarWidth = () => {
    if(scrollbarWidth) return scrollbarWidth;
    if(!canUseDom) return 0;

    // Create the measurement node
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width
    scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // Delete the DIV
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}



// WEBPACK FOOTER //
// ./src/utils/measure.js